import React, { useRef, useState } from "react";
import bgImg from "../../assets/bg-img.svg";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { baseUrl } from "../../utils/constants";
import { jwtDecode } from "jwt-decode";
import { IoIosEyeOff, IoMdEye } from "react-icons/io";

const LoginForm = ({ onLogin }) => {
  const url = window.location.href;
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const password = useRef(null);
  const email = useRef(null);
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.clear();
    navigate("/login");
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${baseUrl}/influencer/login`, {
        email: email.current.value,
        password: password.current.value,
      });

      if (response.data.token && response.data.influencerId) {
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("influencerId", response.data.influencerId);
        const decodedToken = jwtDecode(response.data.token);
        const expiryTime = decodedToken.exp * 1000 - Date.now();

        setTimeout(() => {
          handleLogout();
        }, expiryTime);

        setError("");
        onLogin();
        navigate("/");
      } else {
        setError("Failed to retrieve influencer data");
      }
    } catch (err) {
      if (err.response && err.response.data) {
        setError(err.response.data);
      } else {
        setError("An unexpected error occurred");
      }
    }
  };

  const showPasswordHandler = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <div className="container mt-4 main_container">
      <div className="row">
        <div className="col-md-5">
          <h1 className="heading">Influencer Login</h1>
          <div className="mt-3 img_box">
            <img src={bgImg} alt="bg" />
            <p className="mt-3">
              Log in to access your account and stay connected.
            </p>
            <p className="text-bold">
              {url.includes("/login") ? (
                <>
                  Don't have an account?{" "}
                  <Link className="login_link" to={"/signup"}>
                    Register
                  </Link>
                </>
              ) : (
                <>
                  Already Registered?{" "}
                  <Link className="login_link" to={"/login"}>
                    Login
                  </Link>
                </>
              )}
            </p>
          </div>
        </div>
        <div className="col-md-7">
          <div className="login_form_box">
            <form onSubmit={handleLogin}>
              <div className="row">
                <div className="col-md-12">
                  <div className="mb-3">
                    <label htmlFor="name" className="form-label">
                      Email
                    </label>
                    <input
                      ref={email}
                      type="email"
                      className="form-control"
                      name="email"
                      id="email"
                      placeholder="Enter Email*"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="mb-3 position-relative">
                    <label htmlFor="name" className="form-label">
                      Password
                    </label>
                    <input
                      type={showPassword ? "text" : "password"}
                      ref={password}
                      className="form-control"
                      name="password"
                      id="password"
                      placeholder="Enter Password*"
                      required
                    />
                    {!showPassword ? (
                      <IoMdEye
                        onClick={showPasswordHandler}
                        className="showPassIcon"
                      />
                    ) : (
                      <IoIosEyeOff
                        onClick={showPasswordHandler}
                        className="showPassIcon"
                      />
                    )}
                  </div>
                </div>
                {error && <p style={{ color: "red" }}>{error}</p>}
                <div className="col-md-12">
                  <button type="submit" className="w-100 mt-4 btn btn-primary">
                    Login
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
